export const handleOnlineFormClick = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSftFvKOI-U_XLpYMlo4W4m_Jrq6FXxiStuWdhJoUOsEea4Dnw/viewform?usp=publish-editor', '_blank');
};

export const getCurrentAddmissionYear = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    return `${currentYear} - ${currentYear + 1}`;
};
